var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6daeeb5e73d503cdb7da64305f3254ed7fd2f02c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["legacy@interpals"]={id:"6daeeb5e73d503cdb7da64305f3254ed7fd2f02c"};
      